import type React from 'react';
import type { FC } from 'react';

import { getOS } from '@iconik-io/core/src/os/get_os';

import {
  getAllowSearchUsers,
  getMentionsMode,
} from '../../ducks/asset_comments/selectors';
import { useAppSelector } from '../../store/react_redux_typed';
import MentionsInputFieldWrapper from '../../ui/forms/field_wrappers/mentions_input/mentions_input';
import type { SEGMENT_TYPE_COMMENT } from '../segment_form/constants';
import type { SegmentInputCommonProps } from './types';

import styles from './segment_input_comment.module.css';

type Props = SegmentInputCommonProps & {
  segmentType: typeof SEGMENT_TYPE_COMMENT;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  color?: string;
  placeholder?: string;
  autoFocus?: boolean;
};

export const SegmentInputComment: FC<Props> = (props) => {
  const mentionsMode = useAppSelector(getMentionsMode);
  const allowSearchUsers = useAppSelector(getAllowSearchUsers);

  const {
    color,
    disabled,
    onChange,
    onLayoutChanged,
    onSubmitRequested,
    required = true,
    value,
    onClick,
    autoFocus,
  } = props;

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    const isMacOS = getOS() === 'MacOS';

    if (isMacOS && event.metaKey && event.key === 'Enter') {
      onSubmitRequested?.();
    }
    if (!isMacOS && event.ctrlKey && event.key === 'Enter') {
      onSubmitRequested?.();
    }
  };

  return (
    <div className={styles.root}>
      <MentionsInputFieldWrapper
        className={styles.field}
        controlClassName={styles.control}
        required={required}
        name="segment_text"
        onClick={onClick}
        disabled={disabled}
        hideErrorMessages
        value={value}
        onKeyDown={handleKeyDown}
        onChange={(updatedValue) => {
          onChange(updatedValue ?? '');
          onLayoutChanged?.();
        }}
        mentionsMode={mentionsMode}
        allowSearchUsers={allowSearchUsers}
        placeholderPrefix="Add comment here."
        aria={{
          label: 'Comment input',
        }}
        autoFocus={autoFocus}
      />
      <div
        className={styles.color_marker}
        style={{ backgroundColor: color ?? 'transparent' }}
      />
    </div>
  );
};
